import { Temporal } from 'temporal-polyfill';

export default class Notification {
    static STORAGE_KEY = 'tmf_read_notification_ids';

    static getReadIds() {
        try {
            return JSON.parse(localStorage.getItem(Notification.STORAGE_KEY) ?? '[]');
        } catch {
            return [];
        }
    }

    static markAsRead(id) {
        const readIds = Notification.getReadIds();
        if (!readIds.includes(id)) {
            localStorage.setItem(Notification.STORAGE_KEY, JSON.stringify([...readIds, id]));
        }
    }

    static relativeTime(date) {
        const tz = Temporal.Now.timeZoneId();
        const past = Temporal.Instant.fromEpochMilliseconds(date).toZonedDateTimeISO(tz);
        const now = Temporal.Now.zonedDateTimeISO(tz);
        const { days, hours, minutes } = past.until(now, { largestUnit: 'days' });

        if (days >= 1) return `${ days }d`;
        if (hours >= 1) return `${ hours }h`;
        if (minutes >= 1) return `${ minutes }m`;
        return 'just now';
    }

    constructor(id, type, title, date, url, ctaLabel, description = null, imageUrl = null) {
        this.id = id;
        this.type = type;
        this.title = title;
        this.date = date;
        this.url = url;
        this.ctaLabel = ctaLabel;
        this.description = description;
        this.imageUrl = imageUrl;
        this.isUnread = Notification.getReadIds().includes(id) === false;
    }

    renderTile() {
        const relativeTime = this.constructor.relativeTime(this.date);
        const imageHtml = this.imageUrl ? `<div class="tmf-tile-image"><a href="${ this.url }" target="_blank" rel="noopener noreferrer"><img src="${ this.imageUrl }" alt=""></a></div>` : '';

        return `
            <div class="tmf-notification-tile type-${ this.type }" data-read-status="${ this.isUnread ? 'unread' : 'read' }" data-notification-id="${ this.id }">
                ${ imageHtml }
                <div class="tmf-tile-body">
                    <div class="tmf-tile-title">${ this.title }</div>
                    ${ this.description ? `<div class="tmf-tile-message">${ this.description }</div>` : '' }
                    <div class="tmf-tile-meta">${ relativeTime } ago</div>
                    ${ this.url ? `<a href="${ this.url }" class="tmf-tile-cta" target="_blank" rel="noopener noreferrer">${ this.ctaLabel }</a>` : '' }
                </div>
                <div class="tmf-tile-status"></div>
            </div>
        `;
    }
}
